module.exports = __webpack_public_path__ + "static/media/map_marker.e8ab3615.png";